import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen } from 'lucide-react';
import { posts } from '../blog/posts';

const BlogTeaser = () => {
  const featured = posts.slice(0, 3);

  return (
    <section className="bg-slate-800 py-20 md:py-28" data-testid="blog-teaser-section">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div>
            <div className="flex items-center gap-2 text-cyan-400 text-sm font-semibold mb-3 tracking-wider uppercase">
              <BookOpen className="w-4 h-4" />
              From the Blog
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
              Expert Car Wrap Guides for <span className="text-cyan-400">Sacramento</span>
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-teaser-all-link"
            className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors font-medium whitespace-nowrap"
          >
            All articles <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              data-testid={`blog-teaser-${post.slug}`}
              className="group flex flex-col bg-slate-900/60 rounded-xl overflow-hidden hover:bg-slate-900/90 transition-all duration-300 hover:transform hover:scale-[1.01]"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.imageAlt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-lg font-bold text-white mb-2 leading-snug group-hover:text-cyan-400 transition-colors">
                  {post.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed flex-1">
                  {post.excerpt}
                </p>
                <span className="mt-4 text-cyan-400 text-sm font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                  Read more <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogTeaser;
